// Ficha de producto SRJ: galería, cantidad, cuenta regresiva de entrega, "Comprar ahora" y preguntas frecuentes.
(function () {
  function iniciar(ficha) {
    if (ficha.dataset.srjListo) return;
    ficha.dataset.srjListo = '1';

    // Galería: la miniatura elegida pasa a la imagen principal.
    var imagenes = ficha.querySelectorAll('.srj-ficha__imagen');
    var minis = ficha.querySelectorAll('.srj-ficha__mini');
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var i = mini.dataset.indice;
        imagenes.forEach(function (img) { img.classList.toggle('is-activa', img.dataset.indice === i); });
        minis.forEach(function (m) {
          var activa = m === mini;
          m.classList.toggle('is-activa', activa);
          if (activa) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current');
        });
      });
    });

    // Elegir una foto (desde una miniatura, deslizando la principal o al cerrar el visor)
    var mostrar = function (i) {
      var s = String(i);
      imagenes.forEach(function (img) { img.classList.toggle('is-activa', img.dataset.indice === s); });
      minis.forEach(function (m) {
        var activa = m.dataset.indice === s;
        m.classList.toggle('is-activa', activa);
        if (activa) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current');
      });
    };
    var activaActual = function () {
      var a = ficha.querySelector('.srj-ficha__imagen.is-activa');
      return a ? parseInt(a.dataset.indice, 10) : 0;
    };

    // Deslizar la foto principal de costado en táctil (el scroll vertical sigue siendo de la página)
    var principal = ficha.querySelector('.srj-ficha__principal');
    var total = imagenes.length;
    var toque = null, deslizoEn = 0;
    if (principal && total > 1) {
      principal.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { toque = null; return; }
        toque = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
      }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (!toque) return;
        var dx = e.changedTouches[0].clientX - toque.x, dy = e.changedTouches[0].clientY - toque.y;
        toque = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        deslizoEn = Date.now();
        mostrar((activaActual() + (dx < 0 ? 1 : -1) + total) % total);
      }, { passive: true });
    }

    // Visor a pantalla completa
    var visor = ficha.querySelector('[data-srj-visor]');
    if (visor && principal && typeof visor.showModal === 'function') {
      var pista = visor.querySelector('[data-srj-visor-pista]');
      var fotos = pista.querySelectorAll('img');
      var numeroVisor = visor.querySelector('[data-srj-visor-n]');
      var ant = visor.querySelector('[data-srj-visor-ant]');
      var sig = visor.querySelector('[data-srj-visor-sig]');
      var cargar = function (i) {
        var img = fotos[i];
        if (img && img.dataset.src) {
          img.srcset = img.dataset.srcset; img.src = img.dataset.src;
          delete img.dataset.src; delete img.dataset.srcset;
        }
      };
      var actual = 0;
      var indiceVisor = function () { return Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth)); };
      var actualizar = function () {
        if (!visor.open) return;
        var i = Math.min(fotos.length - 1, Math.max(0, indiceVisor()));
        actual = i;
        numeroVisor.textContent = i + 1;
        cargar(i); cargar(i + 1); cargar(i - 1);
        if (ant) ant.disabled = i === 0;
        if (sig) sig.disabled = i === fotos.length - 1;
      };
      var ir = function (i, suave) {
        pista.scrollTo({ left: i * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
      };
      var abrir = function (i) {
        cargar(i); cargar(i + 1); cargar(i - 1);
        document.body.classList.add('overflow-hidden');
        visor.showModal();
        ir(i, false);
        actualizar();
      };
      principal.addEventListener('click', function () {
        // un deslizamiento recién hecho no abre el visor (el navegador a veces manda un clic al soltar)
        if (Date.now() - deslizoEn < 500) return;
        abrir(activaActual());
      });
      pista.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); }, { passive: true });
      if (ant) ant.addEventListener('click', function () { ir(indiceVisor() - 1, true); });
      if (sig) sig.addEventListener('click', function () { ir(indiceVisor() + 1, true); });
      visor.querySelector('[data-srj-visor-cerrar]').addEventListener('click', function () { visor.close(); });
      visor.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); ir(indiceVisor() + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); ir(indiceVisor() - 1, true); }
      });
      // Tocar el fondo negro (no la foto ni los botones) también cierra
      visor.addEventListener('click', function (e) {
        if (e.target === visor || e.target.classList.contains('srj-visor__foto')) visor.close();
      });
      visor.addEventListener('close', function () {
        document.body.classList.remove('overflow-hidden');
        mostrar(actual);
      });
    }

    // Cantidad
    var numero = ficha.querySelector('.srj-cantidad__numero');
    var menos = ficha.querySelector('[data-srj-menos]');
    var mas = ficha.querySelector('[data-srj-mas]');
    if (numero) {
      var leer = function () { var n = parseInt(numero.value, 10); return isNaN(n) || n < 1 ? 1 : n; };
      if (menos) menos.addEventListener('click', function () { numero.value = Math.max(1, leer() - 1); });
      if (mas) mas.addEventListener('click', function () { numero.value = leer() + 1; });
      numero.addEventListener('change', function () { numero.value = leer(); });
    }

    // Cuenta regresiva: la misma lógica que el componente de Framer (hora límite 12, hora de Uruguay).
    var cuenta = ficha.querySelector('[data-srj-cuenta]');
    if (cuenta) {
      var texto = cuenta.querySelector('[data-srj-cuenta-texto]');
      var barra = cuenta.querySelector('[data-srj-cuenta-barra]');
      var limite = parseInt(cuenta.dataset.horaLimite, 10) || 12;
      var hoy = 'Llega hoy comprando dentro de las próximas XX (Solo Montevideo y alrededores)';
      var manana = 'Llega mañana comprando dentro de las próximas XX (Solo Montevideo y alrededores)';
      var lunes = 'Llega el lunes comprando dentro de las próximas XX (Solo Montevideo y alrededores)';
      var calcular = function () {
        var ahora = new Date();
        var horas = null, minutos = null, avance = 0, esHoy = false, esLunes = false;
        if (ahora.getTimezoneOffset() === 180) {
          var t = ahora.getHours(), n = ahora.getMinutes(), s = ahora.getSeconds(), dia = ahora.getDay();
          if (t < limite) {
            var e = limite - t - 1, a = 60 - n - 1, o = 60 - s === 60 ? a + 1 : a;
            horas = o === 60 ? e + 1 : e; minutos = o === 60 ? 0 : o;
            avance = (t * 60 + n) / (limite * 60) * 100; esHoy = true;
          } else {
            var sabado = dia === 6, oo = 24 - t - 1, ss = 60 - n - 1, c = 60 - s, u = c === 60 ? ss + 1 : ss;
            var f = u + limite * 60;
            horas = Math.floor((oo * 60 + f) / 60) + (sabado ? 24 : 0); minutos = f % 60;
            avance = ((t - limite) * 60 + n) / ((24 - limite) * 60 + limite * 60) * 100; esLunes = sabado;
          }
        }
        var plazo = horas !== null && minutos !== null
          ? horas + ' ' + (horas === 1 ? 'hora' : 'horas') + ' y ' + minutos + ' ' + (minutos === 1 ? 'minuto' : 'minutos')
          : '0 horas y 0 minutos';
        texto.textContent = (esHoy ? hoy : esLunes ? lunes : manana).replace('XX', plazo);
        barra.style.width = avance + '%';
      };
      calcular();
      setInterval(calcular, 1000);
    }

    // Comprar ahora: agrega al carrito y va al pago.
    var ahora = ficha.querySelector('[data-srj-comprar-ahora]');
    var form = ficha.querySelector('form[data-type="add-to-cart-form"]');
    if (ahora && form) {
      ahora.addEventListener('click', function () {
        if (ahora.disabled) return;
        ahora.setAttribute('aria-busy', 'true');
        var datos = new FormData(form);
        var id = form.querySelector('[name="id"]').value;
        datos.set('id', id);
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: datos,
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = '/checkout'; })
          .catch(function () { ahora.removeAttribute('aria-busy'); form.requestSubmit ? form.requestSubmit() : form.submit(); });
      });
    }

    // Preguntas frecuentes
    ficha.querySelectorAll('.srj-faq__pregunta').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var item = boton.closest('.srj-faq__item');
        var abrir = boton.getAttribute('aria-expanded') !== 'true';
        boton.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        item.classList.toggle('is-abierta', abrir);
      });
    });
  }

  function todas() { document.querySelectorAll('.srj-ficha').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();
